import { useSelector } from 'react-redux';
import {
  useQuery,
  DocumentNode,
  ApolloError,
  ApolloQueryResult,
  OperationVariables,
} from '@apollo/client';
import { RootState } from '../../../../store/store';
import { PaginationInput } from '../../../../types/schema/utils.types';
import { Cors } from '../../../../types/schema/cors.types';

interface GetAllCorsDomainsHook {
  data: Cors[] | undefined;
  loading: boolean;
  error: ApolloError | undefined;
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      getAllCorsDomains: Cors[];
    }>
  >;
}

interface GetAllCorsDomainsMutationData {
  getAllCorsDomains: Cors[];
}

interface GetAllCorsDomainsInputType {
  input: PaginationInput;
}

export function useGetAllCorsDomains(
  query: DocumentNode,
  input: PaginationInput
): GetAllCorsDomainsHook {
  const { jwt } = useSelector((state: RootState) => state.auth);

  const { data, loading, error, refetch } = useQuery<
    GetAllCorsDomainsMutationData,
    GetAllCorsDomainsInputType
  >(query, {
    variables: {
      input,
    },
    context: {
      headers: {
        cookie: `jwt=${jwt}`,
        authorization: jwt ? `Bearer ${jwt}` : '',
      },
    },
  });

  return {
    data: data?.getAllCorsDomains,
    loading,
    error,
    refetch,
  };
}
